import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import Heading from '../../shared/atoms/Heading';
import Text from '../../shared/atoms/Text';
import Input from '../../shared/atoms/Input';
import Alert from '../../shared/molecules/Alert';
import Link from '../../shared/atoms/Link';
import Button from '../../shared/atoms/Button';
// Icons
import Confettis56Color from '../../icons/Confettis56Color';

const AddGiftCardHeroBox = ({
  client,
  success,
  errorAdd,
  setErrorAdd,
  giftcard,
  setGiftcard,
  setShowModal,
  loading,
  addCard,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      p={{ xs: 0, md: 7 }}
      mr={{ xs: 0, md: 5 }}
      bg="white"
      boxShadow={{ xs: null, md: 'lg' }}
      borderRadius="md"
      flexDirection={{ xs: 'column-reverse', md: 'row' }}
      alignItems="center"
      mt={{ xs: 0, md: -10 }}>
      <Box flex={1}>
        {!!success && <Confettis56Color mb={2} />}
        <Heading level={3}>
          {success ? t('addgiftcard.headings.1') : t('addgiftcard.headings.2')}
        </Heading>
        <Text mb={4}>
          {success ? t('addgiftcard.texts.1') : t('addgiftcard.texts.2')}
        </Text>
        {!success && (
          <>
            <Input
              mb={4}
              error={errorAdd}
              value={giftcard}
              placeholder={t('addgiftcard.texts.3')}
              onChange={(e) => {
                setGiftcard(e.target.value.toUpperCase());
                setErrorAdd(false);
              }}
            />
            {!!errorAdd && (
              <Alert status="danger" mb={4}>
                <Trans
                  i18nKey="addgiftcard.texts.4"
                  components={{
                    lien: (
                      <Link
                        color="primary.darker"
                        onClick={() =>
                          window.open(
                            `mailto:bonjour@roulezjeunesse.com?subject=Problème carte cadeau`,
                            '_blank',
                          )
                        }
                      />
                    ),
                    annotation: <u />,
                  }}
                />
              </Alert>
            )}
          </>
        )}
        {success ? (
          <Button to="/reparation">{t('button.book')}</Button>
        ) : (
          <Button
            onClick={client.id ? () => addCard() : () => setShowModal(true)}
            loading={loading}>
            {t('buttongiftcardpopup.cta')}
          </Button>
        )}
      </Box>
      <Box
        flex={1}
        mb={{ xs: 4, md: 0 }}
        p={{ xs: 3, md: 4 }}
        alignItems="center"
        justifyContent="center">
        <img
          src="/static/img/pictos/giftcard/roulez-jeunesse-card-3.png"
          alt="Carte cadeau Roulez Jeunesse"
          style={{ width: '80%', height: 'auto' }}
        />
      </Box>
    </Box>
  );
};

export default AddGiftCardHeroBox;
